import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data stays fresh for 5 minutes — switching tabs won't trigger refetch
      staleTime: 5 * 60 * 1000,
      // Keep unused data in cache for 30 minutes (was 15 — longer cache = fewer refetches)
      gcTime: 30 * 60 * 1000,
      // Retry once on failure (not 3 times — avoids hammering a broken endpoint)
      retry: 1,
      // Don't refetch when window regains focus in a fitness app context
      refetchOnWindowFocus: false,
      // Show cached data instantly when navigating back — no loading spinner
      // Data silently refreshes in background only if stale
      refetchOnMount: true,
      placeholderData: (prev) => prev,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
